<template>
  <a @click="OnLogoClick" href="/#/dashboard" class="logo">
    <img src="../assets/images/logo-light.svg" alt="logo" class="logo-light" />
    <img src="static/logo-dark.svg" alt="logo" class="logo-dark" />
  </a>
</template>
<script>
export default {
  props: {
    isToggle: Boolean,
  },
  data() {
    return {
      isActive: false,
    };
  },

  methods: {
    OnLogoClick: function () {
      this.$emit("goToHomePage", this.isActive);
    },
  },
};
</script>